import { useMemo, useState } from 'react';

import { Flex } from '@bonusly/design-system';

import { BizySidePanelChatView } from './bizy-side-panel-chat-view';
import { BizySidePanelHistoryView } from './bizy-side-panel-history-view';
import { BizySidePanelResizeHandle } from './bizy-side-panel-resize-handle';
import { useBizyOpenListener } from './hooks/use-bizy-open-listener';
import { useBizySidePanelStore } from './store/use-bizy-side-panel-store';

export type BizyPanelGradientTheme = 'none' | 'cool-subtle';

interface BizySidePanelProps {
	gradientTheme?: BizyPanelGradientTheme;
	panelLeftEdge: number;
}

export function BizySidePanel({ gradientTheme = 'none', panelLeftEdge }: BizySidePanelProps) {
	const view = useBizySidePanelStore((state) => state.view);
	const showChat = useBizySidePanelStore((state) => state.showChat);
	const showHistory = useBizySidePanelStore((state) => state.showHistory);
	const [resetSignal, setResetSignal] = useState(0);

	useBizyOpenListener();

	const PANEL_BG = 'linear-gradient(173deg, rgba(107, 116, 133, 0.02) 0%, rgba(107, 116, 133, 0.06) 100%)';

	const historyBg = useMemo(() => {
		if (gradientTheme === 'none') return PANEL_BG;
		return 'linear-gradient(180deg, var(--chakra-colors-bg-canvas) 0%, var(--chakra-colors-bg-surface) 100%)';
	}, [gradientTheme]);

	return (
		<Flex
			direction="column"
			h="100%"
			background={view === 'history' ? historyBg : PANEL_BG}
			borderLeft="1px solid"
			borderColor="border.soft"
			position="relative"
			overflow="hidden"
		>
			{view === 'history' ? (
				<BizySidePanelHistoryView
					onBack={showChat}
					onNewConversation={() => {
						setResetSignal((value) => value + 1);
						showChat();
					}}
				/>
			) : (
				<BizySidePanelChatView onOpenHistory={showHistory} resetSignal={resetSignal} />
			)}

			<BizySidePanelResizeHandle panelLeftEdge={panelLeftEdge} />
		</Flex>
	);
}
